import type { Attribute } from '@/api';
import { validateAndUpdateMedicationPadItemDetailUtil } from '@/components/Patient/components/PrescriptionItemEditor/utils/validateAndUpdateMedicationPadItemDetail.utils';
import type { StateCreator } from 'zustand';
import type { MedicationPadItemAttributeValue, PrescriptionAssistantSliceType } from '../types';

/**
 * Writes one attribute onto the pad item as it stands in the store, so a write that lands late, such as the debounced
 * dosage, cannot put back a stale copy of the item over an attribute changed since.
 */
export const updateMedicationPadItemAttribute: StateCreator<
  PrescriptionAssistantSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  <A extends Attribute>(medicationPadItemId: string, attribute: A, value: MedicationPadItemAttributeValue<A>) => void
> = (_set, get) => (medicationPadItemId, attribute, value) => {
  const { prescriptionAssistant, updateMedicationPadItemById } = get();
  const medicationPadItem = prescriptionAssistant.prescriptionPad.medicationPadItems.find(
    (item) => item.medicationPadItemId === medicationPadItemId,
  );
  const medicationPadItemDetail = medicationPadItem?.medicationPadItem;
  if (!medicationPadItem || !medicationPadItemDetail) {
    return;
  }

  // Logs and returns nothing for a value the pad item schema rejects
  const updatedMedicationPadItemDetail = validateAndUpdateMedicationPadItemDetailUtil(medicationPadItemDetail, {
    [attribute]: value,
  });
  if (!updatedMedicationPadItemDetail) {
    return;
  }

  updateMedicationPadItemById({ ...medicationPadItem, medicationPadItem: updatedMedicationPadItemDetail });
};
